import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
  TemplateRef,
  Type
} from '@angular/core';
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {Button} from "primeng/button";
import {NgComponentOutlet} from "@angular/common";

@Component({template: ``,})
export abstract class NotificationPage<T>{
  public readonly data = input.required<T>();
  public readonly closeButton = input.required<TemplateRef<any>>();
}

export interface NotificationPageData<T> {
  component: Type<NotificationPage<T>>,
  data: T,
  disableContinue?: boolean,
}

@Component({
  selector: 'homey-multi-page-notification',
  imports: [
    Button,
    NgComponentOutlet,
  ],
  templateUrl: './multi-page-notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiPageNotificationComponent<T> {
  public readonly ref = inject(DynamicDialogRef);
  public readonly pages = input.required<NotificationPageData<T>[]>();
  public readonly closable = input.required<boolean>();
  protected readonly index = signal(0);
  protected readonly currentPage = computed(() => this.pages()[this.index()]);
  protected readonly showContinue = computed(() => {
    return this.currentPage()?.disableContinue !== true;
  });

  public onContinueClick() {
    if (this.index() < this.pages().length - 1) {
      this.index.update(i => i + 1);
    } else {
      this.ref.close();
    }
  }
}
